import React from 'react'
import styled from 'styled-components'

const List = styled.div`
    cursor: pointer;
    padding-top: 6px;
    padding-bottom: 6px;
    padding-left: 44px;
    padding-right: 16px;
    background: 3c3d4c;

	&:hover {
		color: #ffc300;
        background-color: rgba(22, 22, 27, 1);
	}

    &:active {
		color: #ffc300;
        background-color: rgba(22, 22, 27, 1);
	}
`

const Item = ({id, label, handleDragStart, handleClick}) => {
    const onDragStart = (e) => {
        e.stopPropagation()
        e.preventDefault()
        handleDragStart(e, id)
    }

    const onClick = (e) => {
		e.preventDefault()
		e.stopPropagation()
		handleClick(e)
	}
    
    return (
        <List
            data-list-item-id={id}
            onClick={onClick}
            onDragStart={onDragStart}
            draggable={true}
        >
            {label}
        </List>
    )
}

export default Item
